<style>
  .disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transition: opacity 0.5s;
  }
</style>

<script>
  import { getContext, onMount } from 'svelte';
  import Form from '../../../../components/inputs/form';
  import TextInput from '../../../../components/inputs/text';
  import SwitchInput from '../../../../components/inputs/switch';
  import RichTextInput from '../../../../components/inputs/richtext';
  import SectionNav from '../../../../components/navigation/section';
  import Preview from '../../../../components/buttons/preview.card';
  import CommunicationTypeInput from '../../../../components/inputs/communication.type';
  import DateTimeInput from '../../../../components/inputs/datetime';
  import uuid from 'uuid-browser/v4';
  import {UPDATE_COMMUNICATION, REMOVE_COMMUNICATION, ADD_COMMUNICATION, SEND_EVENT_COMMUNICATION, SEND_TEST_EVENT_COMMUNICATION} from '../../../../graphql/communications';
  import { addNotification, ICONS } from '../../../../utils/notifications.store';
  import moment from 'moment';

  const client = getContext('apollo');

  export let value;
  let program = value;
  export let id;
  export let index = 0;

  

  function changeIndex(i) {
    index = i;
  }

  const NAMES = {
    'Tips': 'Get Ready',
    'ThankYou': 'Thank You',
    'Reminder': 'Reminder'
  }

  const TIMES = {
    'Tips': 'Sent 7 days before the event',
    'ThankYou': 'Sent 2 days after the event',
    'Reminder': 'Sent 2 days before the event'
  }

  function promptRemove(communication) {
    addNotification({
      message:`Are you sure you want to delete ${communication.subject}?`, 
      icon: ICONS.CONFIRM,
      confirm: () => remove(communication)
    })
  }

  async function remove(communication) {
    try {
      if(!communication.new) {
        await client.mutate({mutation: REMOVE_COMMUNICATION, variables:{id: communication.id}});
      }

      value.communications = [...value.communications.filter((c) => c.id !== communication.id)];
      addNotification({ icon: ICONS.SUCCESS,  message:`Removed ${communication.subject}`, time: 3000});
      index = index - 1;
    } catch (e) {
      addNotification({ icon: ICONS.ERROR,  message:`There was an error removing ${communication.subject}`, time: 3000});
    }
    
  }

  async function sendTestCommunication(communication) {
    try {
      const mockEvent = {
        name: value.program.name,
        category: value.program.category.id,
        secondaryCategory: value.program.secondaryCategory.id,
        program: value.program.id,
        date: value.date,
        startTime: moment(value.startTime, 'h:mm A').format('h:mm A'),
        endTime: moment(value.endTime, 'h:mm A').format('h:mm A'),
        staffStartTime:  moment(value.staffStartTime, 'h:mm A').format('h:mm A'),
        staffEndTime:  moment(value.staffEndTime, 'h:mm A').format('h:mm A'),
        constraintCapacityTotal: parseInt(value.constraintCapacityTotal || 0),
        constraintStaff: parseInt(value.constraintStaff || 0),
        constraintAllowEarlyRegistration:
          value.constraintAllowEarlyRegistration || false,
        constraintAllowGroupRegistration:
          value.constraintAllowGroupRegistration || false,
        constraintCapacityGroup: parseInt(value.constraintCapacityGroup || 0),
        leader: value.leader.id,
        notes: value.notes,
        published: value.published,
        registrationOpenDate: value.registrationOpenDate,
        earlyRegistrationOpenDate: value.earlyRegistrationOpenDate,
        constraintPrivate: value.constraintPrivate || false,
        published: value.published,
      }

      console.log(mockEvent);

      const input = {
        type: communication.type,
        subject: communication.subject,
        body: communication.body,
        event: communication.event || value.id,
        useParent: communication.useParent,
        parent: communication.parent
      }

      const event = Object.assign(mockEvent, {
        program: value.program.id,
        leader: value.leader.id
      });

      await client.mutate({mutation: SEND_TEST_EVENT_COMMUNICATION, variables:{
        input,
        event
      }})
      addNotification({ icon: ICONS.SUCCESS,  message:`Sent test for ${communication.subject}`, time: 3000});
    } catch (e) {
      console.log(e);
      addNotification({ icon: ICONS.ERROR,  message:`Couldn't sent test for ${communication.subject}`, time: 3000});
    }
  }

  async function sendEventCommunication(communication) {
    try {
      

      const input = {
        type: communication.type,
        subject: communication.subject,
        body: communication.body,
        event: communication.event || value.id,
      }

      const event =  {
        program: value.program.id,
        leader: value.leader.id
      }

      const response = await client.mutate({mutation: SEND_EVENT_COMMUNICATION, variables:{
        event: communication.event || value.id,
        id: communication.id
      }})

      addNotification({ icon: ICONS.SUCCESS,  message:`Sent test for ${communication.subject} to ${response.data.toString()}`, time: 3000});
    } catch (e) {
      addNotification({ icon: ICONS.ERROR,  message:`Couldn't send for ${communication.subject}`, time: 3000});
    }
  }

  function add(e) {
    e.preventDefault();
    value.communications = [...value.communications,{id:uuid(), new: true, type: 'Custom'}];
    index = value.communications.length - 1;

    return false;
  }

  async function save(communication) {
    const input = {
      type: communication.type,
      subject: communication.subject,
      body: communication.body,
      event: communication.event || value.id,
      useParent: communication.useParent ? true : false,
      parent: communication.parent
    }

    if(communication.type === 'Custom') {
      input.date = communication.date;
      input.parent = null;
      input.useParent = false;
    }

    const variables = {
      input
    }

    if(!communication.new) {
      variables.id = communication.id
    }

    try {
      console.log(variables);
      addNotification({message: 'Saving Communication', icon: ICONS.LOADING});
      const {data} = await client.mutate({mutation: !communication.new ? UPDATE_COMMUNICATION : ADD_COMMUNICATION,variables});
      
      if(communication.new) {
        communication.new = false;
        communication.id = data.addCommunication.id;
      }

      addNotification({message: 'Saved Communication', icon: ICONS.SUCCESS, time: 3000});
    } catch (e) {
      addNotification({message: 'There was an error saving the communication', icon: ICONS.ERROR, time: 3000});
    }
  }

</script>


<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-12">


      <div class="grid-x grid-margin-x">
        <div class="cell small-12 medium-9">
        {#each value.communications as communication, i}
          {#if index === i}
            <Form>
              {#if communication.type === 'Custom'}
              <div class="help">
                {communication.date ? `Sends on ${communication.date}` : ''}
              </div>
              {:else}
              <div class="help">
                {TIMES[communication.type] ? TIMES[communication.type] : ''}
              </div>
              {/if}
              
              
                <div class="form-group">
                  <SwitchInput
                    label="Use Default Program Communication?"
                    name="override"
                    bind:value="{communication.useParent}"
                  ></SwitchInput>
                </div>
              
              <div class:disabled="{communication.useParent}">
                <div class="form-group">
                  <TextInput readonly="{communication.useParent}" disabled="{communication.useParent}" bind:value={communication.subject} placeholder="Subject" label="Subject" />
                </div>
              </div>
              <!--<div class="form-group">
                <CommunicationTypeInput bind:value={communication.type} placeholder="Type" label="Type" ></CommunicationTypeInput>
              </div>-->
              {#if communication.type === 'Custom'}
              <div class="form-group">
                <DateTimeInput bind:value={communication.date} label="Send On Date" placeholder="Send On Date"></DateTimeInput>
              </div>
              {/if}
              <div class:disabled="{communication.useParent}">
                <div class="form-group">
                  <RichTextInput disabled="{communication.useParent}" bind:value={communication.body} placeholder="Body" label="Body" />
                </div>
              </div>
              <div class="grid-x grid-margin-x">
                <div class="cell small-6">
                  <div on:click="{e => sendTestCommunication(communication)}" class="button small secondary">SEND TEST EMAIL</div>
                  {#if communication.new === false && communication.type === 'Custom'}<div on:click="{e => sendEventCommunication(communication)}" class="button save small">SEND EMAIL NOW</div>{/if}
                </div>
                <div class="cell small-6">
                    <div class="text-right">
                        {#if !communication.parent}
                        <div on:click="{e => promptRemove(communication)}" class="button delete">
                          DELETE
                        </div>
                        {/if}
                        
                          <div on:click="{e => save(communication)}" class="button save">
                            SAVE COMMUNICATION
                          </div>
                      </div>
                </div>
              </div>
             
            </Form>
          {/if}
        {/each}
        </div>
        <div class="cell small-12 medium-3">
          <SectionNav hasSub="{true}">
              <ul>
                {#each value.communications as communication, i }
                  <li class:active={i === index} on:click={() => changeIndex(i)}>
                    {NAMES[communication.type] ? NAMES[communication.type] : communication.type}
                  </li>
                {/each}
              </ul>
              <div class="text-center" slot="under">
                <a on:click="{add}" href="">Add Communication</a>
              </div>
            </SectionNav>
          </div>
      </div>
  </div>
</div>
